import {
  Button, Modal, Pagination, Space, Table,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { legalCustomerColumns, physicalCustomerColumns } from '../../../../utils/tableColumns';
import { deleteCustomer, getLegalCustomers, getPhysicalCustomers } from '../../services/customerServices';
import { getLoginFormOptions } from '../../../../services/login/Login.api';
import useTranslation from '../../../hooks/translation/useTranslation';

function CustomersType({ type = 'physical' }) {
  const { trans } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [options, setOptions] = useState({});
  const [loading, setLoading] = useState({
    options: false,
    customers: false,
  });

  const fetchData = async (page, value) => {
    setLoading((prev) => ({
      ...prev,
      customers: true,
    }));
    const res = type === 'physical' ? await getPhysicalCustomers({
      page: page || 1,
      limit: 10,
      ...value,
    }) : await getLegalCustomers({
      page: page || 1,
      limit: 10,
      ...value,
    });
    setData(res);
    setLoading((prev) => ({
      ...prev,
      customers: false,
    }));
  };
  const fetchForm = async () => {
    setLoading((prev) => ({
      ...prev,
      options: true,
    }));
    const res = await getLoginFormOptions();
    setOptions(res.data);
    setLoading((prev) => ({
      ...prev,
      options: false,
    }));
  };

  const handleDelete = async (id) => {
    Modal.confirm({
      title: trans('do_you_want_to_delete'),
      onOk: async () => {
        await deleteCustomer(id);
        fetchData(
          data?.meta?.currentPage,
        );
      },
    });
  };

  const dataSource = data?.data?.map((item) => ({
    ...item,
    ...options,
    edit: (
      <Link to={`/admin/customers/${item.customer.id}/edit`}>
        <Button>
          {trans('edit')}
        </Button>
      </Link>
    ),
    delete: (
      <Button onClick={() => handleDelete(item.customer.id)} danger>
        {trans('delete')}
      </Button>
    ),
  }));

  useEffect(() => {
    fetchData();
    fetchForm();
  }, [type]);

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <Button type="primary" onClick={() => navigate('/admin/customers/add')}>{trans('add_customer')}</Button>
      <div className="overflow-table">
        <Table
          dataSource={dataSource}
          columns={(type === 'physical' ? physicalCustomerColumns : legalCustomerColumns).map(
            (col) => ({
              ...col,
              title: trans(col.title),
            }),
          )}
          pagination={false}
          loading={loading?.customers || loading?.options}
        />
      </div>
      {data?.meta && (
      <Pagination
        total={data?.meta?.totalItems}
        pageSize={data?.meta?.itemsPerPage}
        showSizeChanger={false}
        current={Number(data?.meta?.currentPage)}
        onChange={(e) => fetchData(e)}
      />
      )}
    </Space>
  );
}

export default CustomersType;
